import { ExtraOptions, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/admin/login/login.component';
import { PropertiesComponent } from './components/properties/properties.component';
import { ContactComponent } from './components/contact/contact.component';
import { PropertieDetailsComponent } from './components/propertie-details/propertie-details.component';
import { AuthGuard } from './guards/auth.guard';
import { PrincipalComponent } from './components/admin/principal/principal.component';
import { AdminComponent } from './components/admin/admin/admin.component';
import { UploadComponent } from './components/shared/LoadFiles/upload/upload.component';
import { AddPropertieComponent } from './components/admin/properties/add-propertie/add-propertie.component';
import { UpdatePropertieComponent } from './components/admin/properties/update-propertie/update-propertie.component';

export const ROUTES: Routes = [
  { path: 'inicio', component: HomeComponent },
  { path: 'venta', component: PropertiesComponent },
  { path: 'alquiler', component: PropertiesComponent },
  { path: 'ALL', component: PropertiesComponent },
  { path: 'contacto', component: ContactComponent },

  // 👇 Detalle de propiedad: debe estar antes del wildcard
  { path: 'propiedad/:id', component: PropertieDetailsComponent },

  // 👇 Admin agrupado
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'principal', component: PrincipalComponent, canActivate: [AuthGuard] },
      { path: 'nuevo', component: AddPropertieComponent, canActivate: [AuthGuard] },
      { path: 'editar/:id', component: UpdatePropertieComponent, canActivate: [AuthGuard] },
      { path: 'upload/:id', component: UploadComponent, canActivate: [AuthGuard] },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: '**', redirectTo: 'login' }
    ]
  },

  // 👇 Redirecciones globales
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },

  // 👇 IMPORTANTE: El wildcard DEBE estar AL FINAL
  // Si una ruta no coincide con ninguna de las anteriores, redirige a inicio
  { path: '**', redirectTo: 'inicio' }
];
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled', // 👈 restaura al inicio
  anchorScrolling: 'enabled',           // 👈 permite usar #anclas si las tuvieras
  scrollOffset: [0, 0]                  // opcional, para margen con navbar fijo
};
